import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=38a3a2b6&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=38a3a2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a3a2b6",
  null
  
)

export default component.exports